import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Brain, Heart } from 'lucide-react';
import { Line } from 'react-chartjs-2';

export function ClientMetrics() {
  const data = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Average Recovery',
        data: [75, 82, 78, 85, 80, 88, 84],
        borderColor: 'rgb(34, 197, 94)',
        backgroundColor: 'rgba(34, 197, 94, 0.1)',
        fill: true,
        tension: 0.4
      },
      {
        label: 'Average Strain',
        data: [12.4, 14.2, 11.8, 13.5, 15.1, 10.8, 12.6],
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fill: true,
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(156, 163, 175, 0.1)'
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    }
  };

  const metrics = [
    {
      label: 'Average Recovery',
      value: '82%',
      change: '+5%',
      icon: <Heart className="w-4 h-4" />
    },
    {
      label: 'Average Strain',
      value: '12.8',
      change: '-0.4',
      icon: <Activity className="w-4 h-4" />
    },
    {
      label: 'Sleep Quality',
      value: '88%',
      change: '+3%',
      icon: <Brain className="w-4 h-4" />
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <Activity className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Client Performance Metrics</h2>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg"
          >
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              {metric.icon}
              <span>{metric.label}</span>
            </div>
            <div className="text-2xl font-bold">{metric.value}</div>
            <div className="text-xs text-success mt-1">
              {metric.change} vs last week
            </div>
          </motion.div>
        ))}
      </div>

      <div className="h-64">
        <Line data={data} options={options} />
      </div>
    </div>
  );
}